export enum PersonType {
  PF = 1,
  PJ = 2
}
